module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-42.c0c8a2bf.png";